import React from 'react';
import BulletinData from 'pages/BulletinData';

/**
 * Página "Match das Licitações" — o boletim de produção (BulletinData) em modo
 * match: banner de personalização no topo + faixa "Licitação compatível" nos
 * cards. Reusa 100% do BulletinData (matchMode) pra não duplicar nada.
 */
const MatchLicitacoes: React.FC = () => <BulletinData matchMode />;

export default MatchLicitacoes;
